import React, { Fragment, PureComponent } from 'react'

import { noImg } from '@libs/postTools'
import getSecretColor from '@libs/getSecretColor'

import LazyLoadImg from '@components/LazyLoadImg'
import ClampLines from '@components/ClampLines'

class Cover extends PureComponent {
  static defaultProps = {
    className: '',
    secretColor: '',
    isAD: false,
    isSecret: false,
    img: [],
    img3_4: null,
    title: '',
    text: '',
    handleLoaded: () => false,
  }

  constructor(props) {
    super(props)
    this.bgc = noImg
    this.noImg = {
      _id: '5d22043a51546306ed5a2613',
      uid: 'pop.popdaily_secret',
      type: 'post',
      t: 1562510394732,
      path: this.bgc,
      thumb: this.bgc,
      w: 900,
      h: 1170,
    }
    this.secretStyle = {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 0,
      paddingBottom: '100%',
      borderRadius: '16px',
    }
    if (props.secretColor) {
      this.secretStyle.backgroundColor = `${props.secretColor || getSecretColor()}`
    } else {
      this.secretStyle.backgroundImage = `url('${this.bgc}')`
    }
  }

  _getCoverImgSrc = (coverImg) => {
    const { className } = this.props
    const { path = '', thumb = '' } = coverImg
    return className.includes('PcCarousel') ? path : thumb
  }

  _getIgnoreList = () => ['MobileCarousel', 'PcCarousel', 'random-article']

  _getCoverImgWidthWithOutIgnoreList = (coverImg) =>
    this.props.className.split(' ').some((className) => this._getIgnoreList().includes(className))
      ? 0
      : coverImg.w
  _getCoverImgHeightWithOutIgnoreList = (coverImg) =>
    this.props.className.split(' ').some((className) => this._getIgnoreList().includes(className))
      ? 0
      : coverImg.h

  render() {
    const {
      isAD = false,
      isSecret,
      img = [],
      img3_4 = null,
      title = '',
      text = '',
      handleLoaded,
      editorType,
    } = this.props
    let coverImg = img.length > 0 ? img[0] : this.noImg
    // 新編輯器拿 img3_4 (使用者指定的封面照片) 當 coverImg
    if (editorType === 'creator-v2' && img3_4) {
      coverImg = img3_4
    }
    const coverImgSrc = this._getCoverImgSrc(coverImg)
    const width = this._getCoverImgWidthWithOutIgnoreList(coverImg)
    const height = this._getCoverImgHeightWithOutIgnoreList(coverImg)

    return (
      <Fragment>
        {!isAD && (!img.length || isSecret || coverImgSrc === '') ? (
          <div className="secret-img" style={this.secretStyle}>
            <ClampLines className="secret" lines={5} text={`${title}${text}`} />
          </div>
        ) : (
          <LazyLoadImg
            className="articleCard-img"
            width={width}
            height={height}
            handleLoaded={handleLoaded}
            src={coverImgSrc}
            alt={`${title}${text}`}
          />
        )}
      </Fragment>
    )
  }
}

export default Cover
